import React from 'react'
import { Box, Radio, RadioGroup, Stack, Text } from '@chakra-ui/react'

type BuildiumReversalDateNoticeProps = {
  canReverseOriginal: boolean
  canReverseToday: boolean
  ledgerItemLabel: string
  lockDate?: string | null
  originalReversalDate: string
  selectedReversalDate: string | null
  today?: string | null
  onChange: (date: string) => void
}

export const formatFriendlyDate = (date?: string | null) => {
  if (!date) {
    return ''
  }

  const parsedDate = new Date(`${date}T12:00:00`)

  if (Number.isNaN(parsedDate.getTime())) {
    return date
  }

  return parsedDate.toLocaleDateString('en-US')
}

export default function BuildiumReversalDateNotice({
  canReverseOriginal,
  canReverseToday,
  ledgerItemLabel,
  lockDate,
  originalReversalDate,
  selectedReversalDate,
  today,
  onChange
}: BuildiumReversalDateNoticeProps) {
  const hasDistinctReversalDateOptions = originalReversalDate !== today

  return (
    <Box
      bg='blue.50'
      border='1px solid'
      borderColor='blue.200'
      borderRadius='md'
      color='blue.800'
      px={3}
      py={2}
    >
      {canReverseOriginal && canReverseToday && hasDistinctReversalDateOptions ? (
        <>
          <Text fontSize='sm' fontWeight='semibold' mb={2}>
            Choose the Buildium reversal date.
          </Text>
          <RadioGroup value={selectedReversalDate ?? originalReversalDate} onChange={onChange}>
            <Stack spacing={2}>
              <Radio value={originalReversalDate}>
                Use original date ({formatFriendlyDate(originalReversalDate)})
              </Radio>
              <Radio value={today ?? ''}>Use today ({formatFriendlyDate(today)})</Radio>
            </Stack>
          </RadioGroup>
        </>
      ) : canReverseOriginal ? (
        <Text fontSize='sm'>
          {`This ${ledgerItemLabel} will be reversed in Buildium as of its original posting date (${formatFriendlyDate(
            originalReversalDate
          )}).`}
        </Text>
      ) : (
        <Text fontSize='sm'>
          {`Buildium books are locked as of ${formatFriendlyDate(
            lockDate
          )}. Since this ${ledgerItemLabel} was posted before that, it will be reversed as of today (${formatFriendlyDate(
            today
          )}).`}
        </Text>
      )}
    </Box>
  )
}
